var map = {
	"./step4b-mobile-en.webp": "e284",
	"./step4b-mobile-en@2x.webp": "8002",
	"./step4b-mobile-fr.webp": "2a78",
	"./step4b-mobile-fr@2x.webp": "c302"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2023";